
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8a8 8 0 018-8h24a8 8 0 018 8v24a8 8 0 01-8 8H8a8 8 0 01-8-8V8z","fill":"#EAFCD4"}}),_c('path',{attrs:{"d":"M12 29h1V16h-1a2 2 0 00-2 2v9a2 2 0 002 2zm16-13h-7l1.122-3.368A2 2 0 0020.225 10H20l-5 5.438V29h11l3.912-8.596L30 20v-2a2 2 0 00-2-2z","fill":"#58CE29"}})])
          )
        }
      }
    